import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { addEventToBetSlip, removeEventFromBetSlip } from 'Store/actions';

const findOddInMatchCardOdds = (oddGroupTabs, oddId) => {
  if (!Array.isArray(oddGroupTabs)) return undefined;
  let foundOdd;
  oddGroupTabs.forEach(oddGroupTab => {
    oddGroupTab.matchCardOdds?.forEach(group => {
      group.oddList?.forEach(odd => {
        if (odd.id === oddId) {
          foundOdd = { ...odd };
        }
      });
    });
  });
  
  return foundOdd;
};

// Adds target odd to the betslip if its id and data source provided along with a selector to search it.
// If the event is already in the betslip, removes the event first and adds it again. So odd stays updated in this way.
const useAddExternalOdd = ({
  event,
  targetOddId,
  source,
  data,
  oddSelector = findOddInMatchCardOdds,
  onFinish,
}) => {
  const dispatch = useDispatch();
  
  const { couponDetails, isLoadedFromLS } = useSelector(state => state.betSlip);
  
  useEffect(() => {
    if (targetOddId && data && isLoadedFromLS) {
      const foundOdd = oddSelector(data, targetOddId);
      
      const handleOddAdd = async () => {
        const isEventInBetslip = couponDetails.find(
          item => item.id === event.id
        );
        
        if (foundOdd) {
          if (isEventInBetslip) {
            await dispatch(removeEventFromBetSlip(event.id));
          }
  
          await dispatch(addEventToBetSlip({ event, selectedOdd: foundOdd, source }));

          onFinish(true);
        } else {
          onFinish(false);
        }
      };
      
      handleOddAdd();
    }
  }, [isLoadedFromLS]);
};

export default useAddExternalOdd;
